<!-- 咨询信息 -->
<template>
  <div style="padding:20px;background-color:#fff;">
    <el-table
    :data="dataList"
    stripe
    max-height="600"
    >
      <el-table-column
      prop="name"
      align="center"
      label="姓名"
      >
      </el-table-column>
      <el-table-column
      prop="phone"
      align="center"
      label="电话"
      >
      </el-table-column>
      <el-table-column
      prop="brand"
      align="center"
      label="品牌名"
      >
      </el-table-column>
      <el-table-column
      prop="demand"
      align="center"
      label="需求"
      >
      </el-table-column>
      <el-table-column
      prop="createTime"
      align="center"
      label="咨询日期"
      >
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data() {
    return {
      dataList: []
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      axios.post(`${this.$store.state.apiUrlZero}/TuZero/selectDemandTable`)
      .then(res => {
        console.log(res)
        this.dataList = [...res.data.data]
      })
    }
  }
}
</script>

<style>

</style>